import { useQuery } from "@apollo/client";

import { GiftCardByIdDocument } from "../../__generated__/graphql";

export function useGiftCardById(id: string) {
  const { data, loading, error, refetch } = useQuery(GiftCardByIdDocument, {
    variables: { id },
    skip: !id,
  });

  return { giftCard: data?.giftCard ?? null, loading, error, refetch };
}
